module.exports = __webpack_public_path__ + "img/10-atelier-apprenants.c224a310.jpg";